/* Avena FerraVital listicle — page interaction.
   Self-contained. No reference-origin calls. Degrades to a working page if JS fails
   (all offer buttons are #fl-buy anchors; the form posts to /cart/add). */
(function () {
  'use strict';
  var root = document.querySelector('.fl');
  if (!root) return;
  var $ = function (s, c) { return (c || root).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || root).querySelectorAll(s)); };

  /* smooth jump to the buy box from every offer button */
  $$('[data-fl-jump]').forEach(function (a) {
    a.addEventListener('click', function (e) {
      var t = document.getElementById('fl-buy');
      if (!t) return;
      e.preventDefault();
      var y = t.getBoundingClientRect().top + window.pageYOffset - 10;
      window.scrollTo({ top: y, behavior: 'smooth' });
    });
  });

  /* bottom sticky bar: on after the hero, off while the buy box is on screen */
  (function stickyBar() {
    var bar = $('[data-fl-stk]'), hero = $('.fl-hero'), buy = document.getElementById('fl-buy');
    if (!bar || !hero) return;
    var ticking = false;
    function paint() {
      ticking = false;
      var pastHero = hero.getBoundingClientRect().bottom < 0;
      var b = buy ? buy.getBoundingClientRect() : null;
      var inBuy = b && b.top < window.innerHeight && b.bottom > 0;
      var on = pastHero && !inBuy;
      bar.classList.toggle('is-on', on);
      document.body.classList.toggle('fl-stk-on', on);
      bar.setAttribute('aria-hidden', on ? 'false' : 'true');
      var a = bar.querySelector('a'); if (a) a.tabIndex = on ? 0 : -1;
    }
    window.addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(paint); } }, { passive: true });
    window.addEventListener('resize', paint);
    paint();
  })();

  /* ships-by: next business day in the visitor's own clock */
  var ship = $('[data-fl-ship]');
  if (ship) {
    var d = new Date(); d.setDate(d.getDate() + 1);
    while (d.getDay() === 0 || d.getDay() === 6) d.setDate(d.getDate() + 1);
    ship.textContent = d.toLocaleDateString('en-US', { weekday: 'short', month: 'short', day: 'numeric' });
  }

  /* mobile gallery thumbs */
  var gmain = $('[data-fl-gmain]');
  $$('[data-fl-thumbs] button').forEach(function (b, n, all) {
    b.addEventListener('click', function () {
      if (gmain) gmain.src = b.getAttribute('data-src');
      all.forEach(function (o) { o.classList.toggle('is-on', o === b); });
    });
  });

  /* buy box */
  var cards = $$('[data-fl-card]');
  var form = $('[data-fl-form]');
  var atc = $('[data-fl-atc]');
  var status = $('[data-fl-status]');
  var current = cards.filter(function (c) { return c.classList.contains('is-sel'); })[0] || cards[0];
  var owned = [];
  cards.forEach(function (c) {
    owned.push(c.getAttribute('data-variant'));
    (c.getAttribute('data-gifts') || '').split(',').forEach(function (g) { if (g && owned.indexOf(g) === -1) owned.push(g); });
  });
  function select(card) {
    current = card;
    cards.forEach(function (c) { c.classList.toggle('is-sel', c === card); });
    var i = $('input', card); if (i) i.checked = true;
    var now = $('[data-fl-now]'), was = $('[data-fl-was]');
    if (now) now.textContent = card.getAttribute('data-total');
    if (was) was.textContent = card.getAttribute('data-was');
  }
  cards.forEach(function (c) { c.addEventListener('click', function () { select(c); }); });

  var busy = false;
  function post(url, body) {
    return fetch(url, { method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify(body) })
      .then(function (r) {
        if (!r.ok) return r.json().then(function (j) { throw new Error(j.description || j.message || 'Cart error'); });
        return r.json();
      });
  }
  function add() {
    if (busy || !current) return;
    busy = true;
    var html = atc ? atc.innerHTML : '';
    if (atc) { atc.disabled = true; atc.textContent = 'Adding…'; }
    var items = [{ id: Number(current.getAttribute('data-variant')), quantity: 1 }];
    (current.getAttribute('data-gifts') || '').split(',').forEach(function (g) {
      if (g) items.push({ id: Number(g), quantity: 1, properties: { _free_gift: 'yes' } });
    });
    var updates = {}; owned.forEach(function (id) { updates[id] = 0; });
    /* Opens the theme's slide-out cart; its Checkout carries the Sticky.io hand-off. */
    var drawer = document.querySelector('cart-drawer');
    var ids = [];
    if (drawer && typeof drawer.getSectionsToRender === 'function') {
      ids = drawer.getSectionsToRender().map(function (s) { return s.section || s.id; });
    }
    var body = { items: items };
    if (ids.length) { body.sections = ids.join(','); body.sections_url = window.location.pathname; }
    post('/cart/update.js', { updates: updates })
      .then(function () { return post('/cart/add.js', body); })
      .then(function (data) {
        if (drawer && typeof drawer.renderContents === 'function' && data && data.sections) {
          drawer.classList.remove('is-empty');
          drawer.renderContents(data);
          if (!drawer.classList.contains('active') && typeof drawer.open === 'function') drawer.open(atc);
        } else if (drawer && typeof drawer.open === 'function') {
          drawer.classList.remove('is-empty'); drawer.open(atc);
        } else { window.location.href = '/cart'; return; }
        busy = false; if (atc) { atc.disabled = false; atc.innerHTML = html; }
        if (status) status.hidden = true;
      })
      .catch(function (err) {
        busy = false; if (atc) { atc.disabled = false; atc.innerHTML = html; }
        if (status) { status.hidden = false; status.textContent = (err && err.message) || 'Something went wrong adding that.'; }
      });
  }
  if (form) form.addEventListener('submit', function (e) { e.preventDefault(); add(); });
})();
